
import { Component, OnInit } from '@angular/core';
import { SpinnerService } from 'src/app/services/shared/spinner/spinner.service';
import { ModalSize } from "@signal/component-library/efx-modal";

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    standalone: false
})
export class SpinnerComponent implements OnInit {
  isLoadingBoolean = false;
  loadingNumberGlobal = 0;
  modalSize = ModalSize;

  constructor(
    private spinnerService: SpinnerService
  ) { }

  ngOnInit() {
    this.spinnerService.loading$.subscribe(loadingNumber => {
      this.loadingNumberGlobal = Math.max(loadingNumber, 0);
      this.isLoadingBoolean = this.loadingNumberGlobal > 0;
    });
  }

  onCancelUrl() {
    this.spinnerService.cancel();
  }

}
